export const NUMBER_COLUMNS_S = 1
export const NUMBER_COLUMNS_M = 2
export const NUMBER_COLUMNS_L_XL = 4
